import {EntityTextLimits} from 'constants'

export const USER_INITIALS_ICON_COLORS = [
    //'#3f6bb5', this color used for logged in user
    '#8bc34a',
    '#ff9800',
    '#e91e63',
    '#009688',
    '#b7c621',
    '#2196f3',
    '#4caf50',
    '#607d8b',
    '#f44336',
    '#9c3dac',
    '#00bcd4',
    '#795548',
    '#9e9e9e',
    '#673ab7',
]

export const LOGGED_IN_USER_ICON_COLOR = '#3f6bb5'

export const COMMENTS_SCROLL_TO = {
    RECENTLY_ADDED: 'recentlyAdded',
    LOADED_OLDER: 'loadedOlder'
}

export const LOAD_COMMENTS_LIMIT = 10

export const NUMBER_ALLOWED_CHARACTERS = EntityTextLimits.MAX_CPT_COMMENT


// WEBPACK FOOTER //
// ./web/js/panels/comments/constants.js